module.exports = __webpack_public_path__ + "static/media/prototype-choose-filter.6680cd0d.gif";